import { SET_CONTACTS } from "./types";

const initialState = {
  contactList: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CONTACTS:
      return {
        ...state,
        contactList: payload,
      };

    default:
      return state;
  }
};

export default reducer;
